import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { refreshGrid } from 'spark-grid';
import { successMessage } from 'spark-state/common/messages/messagesReducer';
import ConfirmationDialog from 'spark-ui/ui-kitchen/plates/small/ConfirmationDialog';
import { acknowledgeGapPacket } from 'spark-api/gapPacket/gapPacketService';
import { get } from 'lodash';

const AcknowledgeGapPacketPopup = ({ closeDialog, gapPacketId }) => {
    const dispatch = useDispatch();
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const acknowledgeGP = async () => {
        setIsButtonDisabled(true);
        const response = await dispatch(acknowledgeGapPacket(gapPacketId));
        closeDialog();
        dispatch(successMessage(get(response, 'data.message', 'The gap packet is acknowledged successfully')));
        dispatch(refreshGrid("GapPacketRecipientResultsGrid"));
    };

    return (
        <ConfirmationDialog
            description="You confirm receipt of this Gap Packet Notification."
            cancel={closeDialog}
            confirm={{
                label: 'Acknowledge',
                disabled: isButtonDisabled,
                action: acknowledgeGP
            }}
            title="Acknowledge"
            open
            size="sm"
        />
    );
};

export default AcknowledgeGapPacketPopup;
